import { useFormikContext } from "formik";

const TrasladosPuntosGate = ({ children }) => {
  const { values, setFieldValue, errors } = useFormikContext();

  return children({
    fechaHoraSolicitud: values.fechaHoraSolicitud,
    fechaHoraTurno: values.fechaHoraTurno,
    puntos: values.puntos || [],
    puntosError: typeof errors?.puntos === "string" ? errors.puntos : undefined,
    setFieldValue,
    tramosDefaults: values.tramosDefaults,
    values,
  });
};

TrasladosPuntosGate.displayName = "TrasladosPuntosGate";

export default TrasladosPuntosGate;
